// UX-11B — extrait de `apps/web-admin/src/pages/Reenrollments.tsx` (UX-19,
// seule implémentation "avatar à initiales" de ce monorepo avant ce ticket,
// vérifié par grep AVANT d'écrire quoi que ce soit) vers `packages/ui` — ne
// duplique pas un composant déjà existant sous un nom différent, comme
// explicitement demandé. Comportement STRICTEMENT identique pour les deux
// tons déjà utilisés là-bas (`brand`/`amber`) — `Reenrollments.tsx` importe
// désormais ce composant partagé au lieu d'en garder une copie locale, voir
// ce fichier. Élargi à `gray`/`blue`/`red` pour ce ticket (web-parent réutilise
// déjà ces tons pour ses badges de statut, `Home.tsx#StatusTag`).
// UX-40 — `green` ajouté en symétrie de `StatusTagTone` (l'avatar reprend
// TOUJOURS le ton du badge de statut affiché juste à côté, UX-11B).
export type AvatarTone = 'brand' | 'amber' | 'gray' | 'blue' | 'red' | 'green';

const TONE_CLASSNAMES: Record<AvatarTone, string> = {
  brand: 'bg-brand-100 text-brand-700',
  amber: 'bg-amber-100 text-amber-800',
  gray: 'bg-surface-raised text-text-secondary',
  blue: 'bg-blue-100 text-blue-800',
  red: 'bg-red-100 text-red-800',
  green: 'bg-green-100 text-green-800',
};

// Toujours exactement 2 lettres à partir de deux champs déjà STRUCTURÉS
// (`firstName`/`lastName`), jamais un re-découpage d'une chaîne concaténée —
// même règle déjà établie par `initialsOf()` (UX-19).
export function getInitials(firstName: string, lastName: string): string {
  return `${firstName.charAt(0)}${lastName.charAt(0)}`.toUpperCase();
}

export interface AvatarProps {
  initials: string;
  tone?: AvatarTone;
}

// Purement décoratif (`aria-hidden`) : le nom complet est TOUJOURS affiché en
// texte à côté de cet avatar dans chaque appelant, jamais son seul porteur
// d'information — même convention que l'implémentation d'origine.
export function Avatar({ initials, tone = 'brand' }: AvatarProps) {
  return (
    <div
      aria-hidden="true"
      data-testid="avatar"
      className={`flex h-8 w-8 flex-none items-center justify-center rounded-full text-xs font-bold ${TONE_CLASSNAMES[tone]}`}
    >
      {initials}
    </div>
  );
}
